
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import PageTransition from '@/components/utils/PageTransition';
import AnimatedElement from '@/components/utils/AnimatedElement';
import { motion, Variants } from 'framer-motion';

interface PageWrapperProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ 
  children, 
  title,
  subtitle
}) => {
  // Mouse trail removed — use default system cursor

  return (
    <PageTransition>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        
        {/* custom cursor removed */}
        
        <main className="flex-grow">
          {(title || subtitle) && (
            <div className="container mx-auto px-6 pt-32 pb-12">
              <AnimatedElement animation="slideUp" className="text-center">
                {title && (
                  <h1 className="text-4xl md:text-5xl font-bold mt-4 mb-6">
                    {title}
                  </h1>
                )}
                {subtitle && (
                  <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                    {subtitle}
                  </p>
                )}
              </AnimatedElement>
            </div>
          )}
          
          {children}
        </main>
        
        <Footer />
      </div>
    </PageTransition>
  );
};

export default PageWrapper;
